import React         from 'react';
import CSSModules    from 'react-css-modules';

import style from './style.scss';

import StartEndDateInputs   from '../StartEndDateInputs';
import TimetableSelect      from '../TimetableSelect';
import Button               from '../Button';

const ShowMultipleDaysInput = props => {
    if(!props.show) return null;

    const listSize = props.multipleDaysEventsLists.length;

    // console.log(props.multipleDaysEventsLists);

    return (
        <div>
            {props.multipleDaysEventsLists.map((value, index) => {
                return (
                    <div className={style['multiple-events-container']}>
                        <div className={style['day-title']}>
                            Day {index + 1}
                        </div>
                        <StartEndDateInputs
                            startDate={listSize.length == index + 1 ? props.startDate : value.start_date}
                            startTime={listSize.length == index + 1 ? props.startTime : value.start_time}
                            endDate={listSize.length == index + 1 ? props.endDate : value.end_date}
                            endTime={listSize.length == index + 1 ? props.endTime : value.end_time}
                        />
                        <TimetableSelect
                            timetables={ props.timetables }
                            timetableId={ listSize.length == index + 1 ? props.timetableId : value.timetable_id }
                        />
                    </div>
                )
            })}
        </div>
    )
}

class MultipleDaysEventsInputs extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            eventsListsIndex: null
        }
    }

    componentDidMount() {
        this.setState({eventsListsIndex: 0})
    }

    _setDefaultValues() {
        this.props.startDate.onChange(null);
        this.props.startTime.onChange(null);
        this.props.endDate.onChange(null);
        this.props.endTime.onChange(null);
        this.props.timetableId.onChange(null);
    }

    _addInputs() {

        let id = null;

        if (this.props.multipleDaysEventsLists && this.props.multipleDaysEventsLists.length > 0) {
            id = this.props.multipleDaysEventsLists[this.state.eventsListsIndex].id;
            this.setState({eventsListsIndex: this.state.eventsListsIndex++});
        }

        const newDay = {
            id: id,
            start_date: this.props.startDate.value,
            start_time: this.props.startTime.value,
            end_date: this.props.endDate.value,
            end_time: this.props.endTime.value,
            timetable_id: this.props.timetableId.value
        }

        this.props.onAddClick(newDay);
        this._setDefaultValues();
    }

    _removeInputs() {

        if (this.props.multipleDaysEventsLists && this.props.multipleDaysEventsLists.length > 0) {
            this.setState({eventsListsIndex: this.state.eventsListsIndex--})
        }

        this.props.onRemoveClick();
    }

    render() {

        return (
            <div className={style['container']}>

                <ShowMultipleDaysInput
                    show={ this.props.multipleDaysEventsSelected }
                    startDate={ this.props.startDate }
                    startTime={ this.props.startTime }
                    endDate={ this.props.endDate }
                    endTime={ this.props.endTime }
                    timetables={ this.props.timetables }
                    timetableId={ this.props.timetableId }
                    multipleDaysEventsLists={this.props.multipleDaysEvents}
                />

                {this.props.multipleDaysEventsSelected && (
                    <Button
                    onClick={ this._addInputs.bind(this) }
                    autoWidth="true"
                    theme="success"
                    type="button"
                    className={style['save-button']}
                    >
                    <span>Add</span>
                </Button>
                )}

                {this.props.multipleDaysEvents.length >= 2 && (
                    <Button
                        onClick={ this._removeInputs.bind(this) }
                        autoWidth="true"
                        theme="success"
                        type="button"
                        className={style['save-button']}
                    >
                        <span>Remove</span>
                    </Button>
                )}

            </div>
        );


    }
}


export default (CSSModules(MultipleDaysEventsInputs, style));


// WEBPACK FOOTER //
// ./components/MultipleDaysEventsInputs/index.js